import * as Yup from "yup";

export const microfilmSchema = Yup.object().shape({
  filmCount: Yup.string()
    .matches(/^[0-9]*$/)
    .required(),
  agencyName: Yup.string().required(),
});

export const microfilmDefaultValues = {
  serviceTypeId: "1",
  agencyTypeId: "1",
  filmTypeId: "1",
};
